import axios from "axios";
// 本地测试
export const URL = process.env.VUE_APP_BASE_API_URL
// 线上数据
// export const URL = 'http://dangjian.csxlib.com/api'

function handleResult(res){
    const code = res.data.code
    if(code !== 200 && code !== 0) throw new Error(res.data.message)
    return res.data
}

export function getAction(url,config = {}){
    config.headers = config.headers || {}
    const token = localStorage.getItem('token')
    if(token){
        config.headers['X-User-Token'] = token
    }
    return axios.get(url,config).then(res => {
        return handleResult(res)
    })
}

export function postAction(url, data, config = {}){
    config.headers = config.headers || {}
    const token = localStorage.getItem('token')
    if(token){
        config.headers['X-User-Token'] = token
    }
    return axios.post(url, data, config).then(res => {
        return handleResult(res)
    })
}

/**
 * 栏目页 - 获取栏目数据
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getSideBarData(){
    return getTopicChild('items')
}

/**
 * 获取某一栏目信息
 * @param topicCode
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getTopic(topicCode){
    return getAction(`${URL}/party/open/topic/${topicCode}`)
}

/**
 * 获取某一栏目分类下的子分类
 * @param topicCode
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getTopicChild(topicCode){
    return getAction(`${URL}/party/open/topic/${topicCode}/child`)
}

/**
 * 获取某一栏目下-专辑分页数据
 * @param topicCode
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getTopicPageData(topicCode,params = {}){
    return getAction(`${URL}/party/open/topic/${topicCode}/page`,{params})
}

/**
 * 获取专辑内容
 */
export function getResource(id,params = {}){
    return getAction(`${URL}/party/open/res/${id}`,{params})
}

/**
 * 获取某栏目中首个专辑资源
 */
export function getFirstResourceInTopic(topicCode,params = {}){
    return getTopicPageData(topicCode,{pageSize:1}).then(res => {
        const result = res.result
        if(res.code === 500 || !result){
            throw new Error('栏目不存在')
        }
        const records = result.records
        if(!records || records.length < 0){
            return new Error('没有找到资源')
        }
        return getResource(records[0].id,params)
    })
}

/**
 * 获取专辑内容
 */
 export function getItemResource(resourceId,itemId,params = {}){
    return getAction(`${URL}/party/open/res/${resourceId}/item/${itemId}`,{params})
}

/**
 * 收藏专辑
 */
 export function doCollectResource(resourceId) {
    return postAction(`${URL}/party/open/res/collect/${resourceId}`)
}

/**
 * 取消收藏专辑
 */
 export function rmCollectResource(resourceId) {
    return postAction(`${URL}/party/open/res/remove-collect/${resourceId}`)
}

/**
 * 用户登录
 */
export function doLoginByPwd(data){
    return postAction(`${URL}/party/open/user/login`,data)
}

/**
 * 用户登录
 */
export function doLoginBySmsCode(data){
    return postAction(`${URL}/party/open/user/login`,data)
}

/**
 * 注册
 * @param data
 */
export function doRegister(data){
    return postAction(`${URL}/party/open/user/register`,data)
}

/**
 * 获取验证码图片
 */
export function getCaptcha(key) {
    return getAction(`${URL}/party/open/user/captcha/${key}`)
}

/**
 * 发送图形验证码
 * @param phone
 * @param captcha
 */
export function sendSmsCode(phone,captcha){
    return postAction(`${URL}/party/open/user/sms-code?phone=${phone}`,captcha)
}

/**
 * 获取用户信息
 */
export function getUserinfo(){
    return getAction(`${URL}/party/open/user/userinfo`)
        .then(res => res)
        .catch(err => {
            localStorage.removeItem('token')
            throw err
        })
}

/**
 * 用户签到
 */
export function signIn(){
    return postAction(`${URL}/party/open/user/sign-in`)
}

/**
 * 更新用户信息
 */
export function doUpdate(data){
    return postAction(`${URL}/party/open/user/userinfo`,data)
}

/**
 * 获取用户当日积分
 */
export function getPointToday() {
    return getAction(`${URL}/party/open/user/point/simple`)
}

/**
 * 获取积分规则
 */
export function getPointRule() {
    return getAction(`${URL}/party/open/user/point/detail`)
}

/**
 * 获取历时积分数据
 */
export function getPointHistory(params = {pageNum: 1}) {
    return getAction(`${URL}/party/open/user/point/history`,{params})
}

/**
 * 搜索
 */
export function search(params = {}) {
    return getAction(`${URL}/party/open/common/search`,{params})
}

/**
 * 搜索综合
 */
 export function searchMix(params = {}) {
    return getAction(`${URL}/party/open/digital-resource/search/mix`,{params})
}

/**
 * 获取积分商场分页数据
 */
export function getGoodsByTopic(params = {}) {
    return getAction(`${URL}/party/open/point-market/page`,{params})
}

/**
 * 增加积分
 */
export function pointCallback(resourceId,itemId = null) {
    return getAction(`${URL}/party/open/res/${resourceId}/callback`,{params:{itemId}})
}

/**
 * 获取商品信息
 */
export function getGoodsInfo(id) {
    return getAction(`${URL}/party/open/point-market/${id}`)
}

/**
 * 兑换商品
 */
export function order(data) {
    return postAction(`${URL}/party/open/order/`, data)
}

/**
 * 获取订单详情
 */
export function getOrderInfo(id) {
    return getAction(`${URL}/party/open/order/${id}`)
}

/**
 * 获取订单列表
 */
export function getOrderList(params = {}) {
    return getAction(`${URL}/party/open/order/page`, {params})
}

/**
 * 获取用户收藏列表
 */
export function getUserStarList(params = {}) {
    return getAction(`${URL}/party/open/user/collect/page`, {params})
}

const uploadInstance = axios.create({

    headers:{"Conten-Type":"multipart/form-data"},
});

/**
 * 上传头像
 * @param file 文件对象
 */
export function uploadProfile(file){
    const token = localStorage.getItem('token')
    const url = `${URL}/party/open/user/profile`
    const formData = new FormData()
    formData.set('file',file)
    return uploadInstance.post(url,formData,{
        headers:{
            'X-User-Token':token,
        }
    }).then(res => {
        return handleResult(res)
    })
}



/**
 * 评论资源
 */
export function doComment(data) {
    return postAction(`${URL}/party/open/comment/release`, data)
}

/**
 * 获取评论列表
 */
export function getCommentList(itemId, params = {}) {
    return getAction(`${URL}/party/open/comment/item/${itemId}`, {params})
}

/**
 * 点赞评论
 */
export function doStarComment(itemId, commentId) {
    return postAction(`${URL}/party/open/comment/support/${itemId}/${commentId}`)
}

/**
 * 点赞专辑
 */
 export function doStarResource(itemId, commentId) {
    return postAction(`${URL}/party/open/res/support/${itemId}/${commentId}`)
}
